<template>
  <h4>Счет: <strong>{{ formattedCode }}</strong></h4>
</template>

<script>
  import utils from '../../../../utils';

  export default {
    name: "PanelBlueLabelInvoice",
    props: ['invoice'],
    computed: {
      formattedCode() {
        if (!this.invoice) {
          return '';
        }
        return utils.formatInvoice(this.invoice);
      }
    }
  }
</script>

<style scoped>
  h4 {
    font-size: 12px;
    color: #666;
    font-family: Verdana,sans-serif;
    font-weight: normal;
  }

  strong {
    color: #424242;
  }
</style>
